import type { ReactNode } from 'react'

/** KPI tiles: a caps label over a number, in a row of sunken boxes. */
export function Kpis({ items }: { items: readonly { label: string; value: ReactNode; unit?: string }[] }) {
  return (
    <div className="kpis">
      {items.map((k) => (
        <div key={k.label} className="kpi">
          <span className="kpi__label">{k.label}</span>
          <span className="kpi__value">
            {k.value}
            {k.unit && <span className="kpi__unit">{k.unit}</span>}
          </span>
        </div>
      ))}
    </div>
  )
}

/** An empty list: an icon tile, a title, at most one line, and an optional action. */
export function EmptyState({ icon, title, children, action }: { icon?: ReactNode; title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty-state">
      {icon && <span className="icon-tile">{icon}</span>}
      <span className="empty-state__title">{title}</span>
      {children && <span>{children}</span>}
      {action}
    </div>
  )
}

/** A state word with a dot: Ready, Desk open, On break. */
export function StatusChip({ tone, children }: { tone?: 'ok' | 'warn' | 'bad'; children: ReactNode }) {
  return (
    <span className="chip-status" data-tone={tone}>
      {children}
    </span>
  )
}
